<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div class="w-full mb-4 text-black-900">
    <el-table-v2
      class="baseTable"
      :columns="columns"
      :data="listData"
      :width="tableWidth"
      :height="tableHeight"
      :row-event-handlers="{ onDblclick: cellClick }"
      :row-class="'cursor-pointer'"
      fixed
    >
      <template #overlay v-if="loading">
        <div class="el-loading-mask flex items-center justify-center">
          <el-icon class="is-loading" color="var(--el-color-primary)" :size="32">
            <Loading />
          </el-icon>
        </div>
      </template>
    </el-table-v2>
  </div>
  <div class="mt-2 flex justify-between">
    <div class="mr-10 leading-[32px]">
      <div class="max-lg:hidden max-md:hidden">
        共 {{ pagination.total }} 条记录 第 {{ pagination.page }}/{{
          Math.ceil(pagination.total / pagination.pageSize)
        }}页
      </div>
    </div>

    <el-pagination
      class="flex justify-end"
      background
      v-model:current-page="pagination.page"
      v-model:page-size="pagination.pageSize"
      :page-sizes="[10, 20, 50, 100, 500]"
      layout="prev, pager, next ,sizes"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :total="pagination.total"
    >
    </el-pagination>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import type { Column } from 'element-plus'
import type { PropType } from 'vue'

defineProps({
  columns: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    type: Array as PropType<Column<any>[]>,
    required: true,
  },
  listData: {
    type: Array,
    required: true,
  },
  pagination: {
    type: Object,

    default: () => ({
      total: 10,
      page: 1,
      pageSize: 10,
    }),
  },
  cellClick: {
    type: Function,
    default: () => {},
  },
  loading: {
    type: Boolean,
    default: false,
  },
})
const emit = defineEmits(['getList'])

const currentPage = ref(1)
const currentPageSize = ref(10)

const handleCurrentChange = (page: number) => {
  currentPage.value = page
  emit('getList', currentPage.value, currentPageSize.value)
}

const handleSizeChange = (pagesize: number) => {
  currentPageSize.value = pagesize
  emit('getList', currentPage.value, currentPageSize.value)
}

const tableWidth = ref()
const tableHeight = ref()
onMounted(() => {
  const handleResize = () => {
    const mainEl = document.querySelector('body')
    const tableEl = document.getElementsByClassName('baseTable')[0].getBoundingClientRect()

    if (mainEl) {
      tableWidth.value = mainEl?.clientWidth - 88 - 248
      const h =
        mainEl?.clientHeight - 100 - tableEl?.y > 550
          ? mainEl?.clientHeight - 100 - tableEl?.y
          : 550
      tableHeight.value = tableEl ? h : mainEl?.clientHeight - 315
    }
  }
  handleResize()

  window.addEventListener('resize', handleResize)

  // 清理函数，用于移除事件监听器
  return () => {
    window.removeEventListener('resize', handleResize)
  }
})
</script>
<style lang="less" scoped>
:deep(.el-table-v2__overlay) {
  z-index: 9;
}
:deep(.el-table-v2__header-cell) {
  color: #222;
}
:deep(.el-table-v2__row) {
  color: #666;
}
</style>
